import { useViewMode } from '../../contexts/ViewModeContext';
import { Monitor, Smartphone } from 'lucide-react';

export default function ViewToggleBanner() {
  const { viewMode, toggleViewMode } = useViewMode();

  return (
    <button
      onClick={toggleViewMode}
      className="fixed top-[5px] right-3 z-[100] flex items-center gap-1.5 bg-white/80 backdrop-blur-md border border-gray-200 shadow-sm px-2.5 py-1 rounded-full text-[10px] font-semibold text-[#063D2F] hover:bg-white/95 active:scale-95 transition-all"
      data-testid="view-toggle"
      title={`Switch to ${viewMode === 'mobile' ? 'Desktop' : 'Mobile'} View`}
    >
      {viewMode === 'mobile' ? (
        <><Monitor className="w-3.5 h-3.5" /> Desktop</>
      ) : (
        <><Smartphone className="w-3.5 h-3.5" /> Mobile</>
      )}
    </button>
  );
}
